import type { Variants } from "motion/react";
import { useAnimation } from "motion/react";
import * as m from "motion/react-m";
import { forwardRef, useImperativeHandle } from "react";

import { cn } from "@/shared/lib";
import type { AnimatedIconProps } from "@/shared/ui/animated-icon";

export interface XIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

const PATH_VARIANTS: Variants = {
  normal: {
    opacity: 1,
    pathLength: 1,
  },
  animate: {
    opacity: [0, 1],
    pathLength: [0, 1],
  },
};

const XIcon = forwardRef<XIconHandle, AnimatedIconProps>(
  ({ className, size = 24, ...props }, ref) => {
    const controls = useAnimation();
    useImperativeHandle(ref, () => {
      return {
        startAnimation: () => controls.start("animate"),
        stopAnimation: () => controls.start("normal"),
      };
    });

    return (
      <svg
        className={cn("lucide", className)}
        {...props}
        fill="none"
        height={size}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <m.path
          animate={controls}
          d="M18 6 6 18"
          variants={PATH_VARIANTS}
        />
        <m.path
          animate={controls}
          d="m6 6 12 12"
          transition={{ delay: 0.2 }}
          variants={PATH_VARIANTS}
        />
      </svg>
    );
  }
);

XIcon.displayName = "XIcon";

export { XIcon };
